import { ClientStorage, clientStorageFromWindow } from './clientstorage';
import { AnyJson } from './../json/json.utils';
import { urlToString } from './../url/url.utils';
import { freezeDeep } from './../js/js.utils';
import { hashToIdentifier, hashString, longHash } from './../hash/hash.utils';
import { UrlConfig } from './../../api';
import { dbgAddSource } from './../debug/debug.utils';

const LOGGER = 'ClientStorageService';

export class ClientStorageService implements ClientStorage {

  // override ClientStorage
  get: (aKey: string) => AnyJson;
  put: (aKey: string, aValue: AnyJson) => void;

  constructor(aUrlsService: UrlConfig, aWindow?: Window) {
    // this references
    const that = this;

    // access the delivery URL
    const _deliveryRoot = urlToString(aUrlsService.deliveryUrl) || '';
    const _scope = hashToIdentifier(Math.abs(hashString(longHash(), _deliveryRoot)));

    // construct the object
    const _storage = clientStorageFromWindow(_scope, aWindow);

    // set the getters
    that.get = (aKey: string): AnyJson => {
      // dispatch
      const result = _storage.get(aKey);
      // ok
      return freezeDeep(dbgAddSource(LOGGER, result));
    };

    that.put = (aKey: string, aValue: AnyJson): void => {
      // dispatch
      _storage.put(aKey, aValue);
    };

  }
}
